import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineSuppAndOfflineOfficeProperties, OfflineSupplierProperties } from '../Models/OfflineSupplierProperties';
import { OfflinesuppliersService } from '../Services/offlinesuppliers.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular';
import { DxiColumnModule, DxoSearchPanelModule, DxoPagingModule, DxoPagerModule, DxoScrollingModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { Bind } from 'primeng/bind';
import { ToggleSwitch } from 'primeng/toggleswitch';

@Component({
    selector: 'app-offline-supplier-list',
    templateUrl: './offline-supplier-list.component.html',
    styleUrls: ['./offline-supplier-list.component.css'],
    imports: [NavMenuComponent, NgClass, FormsModule, DxDataGridModule, DxiColumnModule, DxTemplateModule, Bind, ToggleSwitch, DxoSearchPanelModule, DxoPagingModule, DxoPagerModule, DxoScrollingModule]
})
export class OfflineSupplierListComponent implements OnInit {
  offlineSuppliersDetails: OfflineSupplierProperties[] = [];
 
  isOpen: boolean = false;
  constructor(private offlineSupplierservice: OfflinesuppliersService, private router: Router) { }

  ngOnInit() {
    this.getSuppliers();
  }
  toggleAccordion() {
    this.isOpen = !this.isOpen;
  }
  createSupplier() {
    localStorage.setItem("TypeCheck", "Create");
    this.router.navigateByUrl("/offlineSupplier");
  }

  updateSupplier(offlineSupplierId) {
    localStorage.setItem("OffSupplierId", offlineSupplierId);
    localStorage.setItem("TypeCheck", "Update");
    this.router.navigateByUrl("/offlineSupplier");
  }

  getSuppliers() {
    this.offlineSupplierservice.getOfflineSupplier().subscribe((data) => {
      this.offlineSuppliersDetails = data;

    });
  }

  changeStatus(obj: OfflineSupplierProperties) {

    this.offlineSupplierservice.UpdateStatus(obj.offlineSupplierId, obj.isActive).subscribe((data) => {


    });

  }
}
